import { render, staticRenderFns } from "./item-autocomplete.vue?vue&type=template&id=31d0d261"
import script from "./item-autocomplete.vue?vue&type=script&lang=js"
export * from "./item-autocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian-bitbucket-pipelines-runner/8cc7fca4-30ca-5724-915b-9e55d5143525/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31d0d261')) {
      api.createRecord('31d0d261', component.options)
    } else {
      api.reload('31d0d261', component.options)
    }
    module.hot.accept("./item-autocomplete.vue?vue&type=template&id=31d0d261", function () {
      api.rerender('31d0d261', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/autocomplete/item-autocomplete.vue"
export default component.exports